import { render, staticRenderFns } from "./EstimateTabs.vue?vue&type=template&id=10a6427a&"
import script from "./EstimateTabs.vue?vue&type=script&lang=js&"
export * from "./EstimateTabs.vue?vue&type=script&lang=js&"
import style0 from "./EstimateTabs.vue?vue&type=style&index=0&id=10a6427a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports